var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17264",
    "data-name": "Group 17264",
    transform: "translate(19104 16069)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(-19104 -16069)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "distance",
    transform: "translate(-19103 -16068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17263",
    "data-name": "Group 17263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17262",
    "data-name": "Group 17262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8338",
    "data-name": "Path 8338",
    d: "M344.251,0a2.92,2.92,0,0,0-2.917,2.917c0,1.4,2.067,4.218,2.551,4.861,0,.208,0,.411-.005.6a.365.365,0,0,0,.355.374h.01a.365.365,0,0,0,.364-.355c.005-.192,0-.4.005-.615.481-.638,2.553-3.467,2.553-4.864A2.92,2.92,0,0,0,344.251,0Zm0,3.646a.729.729,0,1,1,.729-.729A.73.73,0,0,1,344.251,3.646Z",
    transform: "translate(-329.667)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8339",
    "data-name": "Path 8339",
    d: "M293.4,306.071a2.962,2.962,0,0,0-1.135,1.35.365.365,0,1,0,.657.315,2.178,2.178,0,0,1,.838-1.032.364.364,0,1,0-.36-.634Z",
    transform: "translate(-282.238 -295.564)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8340",
    "data-name": "Path 8340",
    d: "M186.432,460.047a3.993,3.993,0,0,1-1.27.667.365.365,0,0,0,.226.694,4.773,4.773,0,0,0,1.5-.788.365.365,0,1,0-.453-.572Z",
    transform: "translate(-178.59 -444.246)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8341",
    "data-name": "Path 8341",
    d: "M256.552,383.732a.364.364,0,0,0-.472.208,8.525,8.525,0,0,1-.643,1.366.365.365,0,0,0,.622.38,9.233,9.233,0,0,0,.7-1.483A.365.365,0,0,0,256.552,383.732Z",
    transform: "translate(-246.654 -370.592)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8342",
    "data-name": "Path 8342",
    d: "M367.693,279.259a.366.366,0,0,0-.506.1c-.12.177-.366.421-1.109.488a.365.365,0,0,0,.032.728h.033a2.067,2.067,0,0,0,1.647-.805A.365.365,0,0,0,367.693,279.259Z",
    transform: "translate(-353.245 -269.654)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8343",
    "data-name": "Path 8343",
    d: "M5.239,181.609c1.15-1.227,3.511-4.049,3.511-6.567a4.329,4.329,0,0,0-4.375-4.375A4.329,4.329,0,0,0,0,175.042c0,3.234,3.9,6.978,4.117,7.184h0l.007.006a.342.342,0,0,0,.051.032.356.356,0,0,0,.063.04.364.364,0,0,0,.137.028q.4,0,.757-.027a.365.365,0,0,0,.336-.391A.358.358,0,0,0,5.239,181.609Zm-.864-4.38a2.188,2.188,0,1,1,2.188-2.187A2.19,2.19,0,0,1,4.375,177.229Z",
    transform: "translate(0 -164.834)",
    fill: "#3f2566"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/Distance.ca1b6967504cdd5db48c36b00c057327.svg";
export { ForwardRef as ReactComponent };